import moment from 'moment';

export function dateNumberToMoment(date) {
  if (typeof date === 'number') {
    switch (date.toString().length) {
      case 8:
        return moment(date, 'YYYYMMDD');
      case 14:
        return moment(date, 'YYYYMMDDHHmmss');
      case 12:
        return moment(date, 'YYYYMMDDHHmm');
      default:
        return moment(date);
    }
  } else {
    return moment(date);
  }
}

export function dateNumberToMomentUtc(date) {
  if (typeof date === 'number') {
    switch (date.toString().length) {
      case 8:
        return moment.utc(date, 'YYYYMMDD');
      case 14:
        return moment.utc(date, 'YYYYMMDDHHmmss');
      case 12:
        return moment.utc(date, 'YYYYMMDDHHmm');
      default:
        return moment.utc(date);
    }
  } else {
    return moment.utc(date);
  }
}
